import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router, RouterStateSnapshot } from '@angular/router';
import { finalize, Subject, takeUntil, takeWhile, tap, timer } from 'rxjs';

interface Scope {
	countdown: number;
	countdownMapping: any;
	accessUrl?: string;
	userNameLogged?: string;
	accessTime?: Date;
	errorMessage?: string;
	errorKey?: string;
}

@Component({
	selector: 'jhi-not-found',
	templateUrl: './not-found.component.html',
	standalone: false,
})
export class NotFoundComponent implements OnInit, OnDestroy {
	scope: Scope = {
		countdown: 3,
		countdownMapping: {
			'=1': '# segundo',
			other: '# segundos',
		},
	};

	private _unsubscribeAll: Subject<any> = new Subject<any>();

	constructor(private _router: Router) {}

	ngOnInit(): void {
		// Redirect after the countdown
		timer(1000, 1000)
			.pipe(
				finalize(() => {
					this._router.navigate(['signed-in-redirect']);
				}),
				takeWhile(() => this.scope.countdown > 0),
				takeUntil(this._unsubscribeAll),
				tap(() => this.scope.countdown--)
			)
			.subscribe();
	}

	ngOnDestroy(): void {
		// Unsubscribe from all subscriptions
		this._unsubscribeAll.next(null);
		this._unsubscribeAll.complete();
	}
}
